import { cn } from '../../lib/utils';
import type { UseFormResult } from './useForm';

type Props<T> = {
  form: UseFormResult<T>;
  className?: string;
};

/**
 * Renders the form's top-level submit error (caught from `onSubmit`). Carries
 * a stable `data-testid="form-submit-error"` so `createFormHarness().submitError()`
 * can read it without consumers having to add a test id by hand.
 *
 * Returns null when there's no error to show.
 */
export function FormSubmitError<T>({ form, className }: Props<T>) {
  if (!form.submitError) return null;
  return (
    <p
      data-testid="form-submit-error"
      role="alert"
      className={cn('text-sm text-destructive', className)}
    >
      {form.submitError}
    </p>
  );
}
